import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-mat-input-validate-messages',
    template: `
		<div class="mat-form-field-subscript-wrapper mt-2">
			<mat-error>
				<span *ngFor="let message of messages">{{ message }}</span>
			</mat-error>
		</div>
	`,
    standalone: false
})
// tslint:disable-next-line: component-class-suffix
export class MatInputValidateMessages {
	@Input() messages: string[];

	get className() {
		return 'invalid-feedback';
	}

	constructor() {}
}
